import { render, staticRenderFns } from "./SmallCard.vue?vue&type=template&id=00f91426&scoped=true&"
import script from "./SmallCard.vue?vue&type=script&lang=ts&"
export * from "./SmallCard.vue?vue&type=script&lang=ts&"
import style0 from "./SmallCard.vue?vue&type=style&index=0&id=00f91426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f91426",
  null
  
)

export default component.exports